import { render, staticRenderFns } from "./InplaySelectedGameNew.vue?vue&type=template&id=531ce2af&scoped=true"
import script from "./InplaySelectedGameNew.vue?vue&type=script&lang=js"
export * from "./InplaySelectedGameNew.vue?vue&type=script&lang=js"
import style0 from "./InplaySelectedGameNew.vue?vue&type=style&index=0&id=531ce2af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ce2af",
  null
  
)

export default component.exports